import { useState } from 'react';
import { AddGapModal, GapFillerView, resumeGap } from '@elva/ui';
import { useNavigate } from 'react-router-dom';
import { useGapHold } from '../hooks/useGapHold';
import { usePeriodRange } from '@/app/hooks/usePeriodRange';

/**
 * Gap Filler agent page (amendment 26 §2). Working now sits above the 30-day
 * dashboard. Every button does something: Add a gap opens the modal, View opens
 * the gap's detail page, Resume resumes a paused gap in the shared store, Hold
 * holds the agent.
 */
export function GapFillerPage() {
  const navigate = useNavigate();
  const { onHold, setHold } = useGapHold();
  const [period, setPeriod] = usePeriodRange();
  const [addOpen, setAddOpen] = useState(false);
  const [, force] = useState(0);

  return (
    <>
      <GapFillerView
        onHold={onHold}
        onSetHold={setHold}
        period={period}
        onPeriodChange={setPeriod}
        onAddGap={() => { setAddOpen(true); }}
        onOpenGap={(id) => { void navigate(`/ai-team/gap-filler/${id}`); }}
        onResumeGap={(id) => {
          resumeGap(id);
          force((n) => n + 1);
        }}
        onOpenSettings={() => { void navigate('/settings/ai/gap-filler'); }}
        onOpenTriage={() => { void navigate('/triage?source=gap-filler'); }}
        onViewAllLogs={() => { void navigate('/communications?agent=gap-filler'); }}
      />
      <AddGapModal open={addOpen} onClose={() => { setAddOpen(false); }} onSubmit={() => { setAddOpen(false); }} />
    </>
  );
}
